const getApiErrorMessage = (error) => {
  const message = error.response?.data?.message ||
    error.response?.data?.error ||
    'Failed. Please try again.';
  
  // Hide technical SQL/database errors from users
  if (message.includes('SQLSTATE') || 
      message.includes('Column not found') || 
      message.includes('Unknown column') ||
      message.includes('Syntax error') ||
      message.includes('mysql') ||
      message.includes('Connection:')) {
    return 'An error occurred while processing your request. Please contact support if the issue persists.';
  }
  
  return message;
};

export default getApiErrorMessage;